import Vue from 'vue'
import VueRouter from 'vue-router'
import goTo from 'vuetify/lib/services/goto'
import store from '@/store'

// import PagesHR from '../helpers/HR'
// import HR from '../views/HR'
// import RouteHR from './hr'
// import PagesLeaves from '../helpers/Leaves'
// import RouteLeaves from './leaves'
// import Leaves from '../views/Leaves'
// import PagesMaster from '../helpers/Master'
// import RouteMaster from './master'
// import Master from '../views/Master'
// import PagesBlog from '../helpers/Blog'
// import RouteBlog from './blog'
// import Blog from '../views/Blog'
// import Pages from '../helpers/Pages'
// import PublicPages from '@/router/PublicPages'
// import PublicRoute from '@/router/PublicRoute'

// ** E-Ticket ** //
// import PagesETicket from '../helpers/ETicket'
// import RouteETicket from './eticket'
// import ETicket from '../views/ETicket'

// ** EVENT ** //
// import PagesEvent from '../helpers/Event'
// import Event from '../views/Event'
// import RouteEvent from './event'

// ** PROJECT ** //
// import PagesProject from '../helpers/Project'
// import Project from '../views/Project'
// import RouterProject from './project'

// ** CONTACT ** //
// import PagesContact from '../helpers/Contact'
// import Contact from '../views/Contact'
// import RouterContact from './contact'

// Layouts

Vue.use(VueRouter)
const routes = [
  {
    path: '',
    component: () => import('../layouts/public/Index.vue'),
    meta: { requiresAuth: false },
    children: [
      {
        path: '/',
        name: 'PublicPage',
        component: () => import('../views/pages/Public.vue')
      }
    ]
  },
  {
    path: '/',
    component: () => import('../layouts/cms/Index.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/pages/cms/Dashboard/Index.vue')
      },
      {
        path: 'home',
        name: 'Home',
        component: () => import('../views/pages/cms/Dashboard/Index.vue')
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('../views/pages/cms/Contacts/Index.vue')
      },
      {
        path: '/HR/companies',
        name: 'Companies',
        component: () => import('../views/pages/cms/Company/Paginate.vue')
      },
      {
        path: '/HR/branches',
        name: 'Branches',
        component: () => import('../views/pages/cms/Branch/Paginate.vue')
      },
      {
        path: '/HR/employees',
        name: 'Employees',
        component: () => import('../views/pages/cms/Employee/Paginate.vue')
      },
      {
        path: '/HR/units',
        name: 'Units',
        component: () => import('../views/pages/cms/Unit/Paginate.vue')
      },
      {
        path: '/HR/job/titles',
        name: 'JobTitle',
        component: () => import('../views/pages/cms/JobTitle/Paginate.vue')
      },
      {
        path: '/HR/job/positions',
        name: 'JobPositions',
        component: () => import('../views/pages/cms/JobPosition/Paginate.vue')
      },
      {
        path: '/HR/attendances',
        name: 'Attendances',
        component: () => import('../views/pages/cms/Attendance/Index.vue')
      },
      // MASTER
      {
        path: '/masters/menu',
        name: 'MasterMenu',
        component: () => import('../views/pages/cms/MasterMenu/Index.vue')
      },
      {
        path: '/masters/menu-group',
        name: 'GroupsMenu',
        component: () => import('../views/pages/cms/MenuList/Index.vue')
      },
      {
        path: '/masters/users',
        name: 'MastersUsers',
        component: () => import('../views/pages/cms/MasterUser/paginate.vue')
      },
      {
        path: '/masters/roles',
        name: 'MastersRoles',
        component: () => import('../views/pages/cms/MasterRole/paginate.vue')
      },
      {
        path: '/masters/educations',
        name: 'Educations',
        component: () => import('../views/pages/cms/Education/Paginate.vue')
      },
      {
        path: '/leaves/report',
        name: 'ReportLeaves',
        component: () => import('../views/pages/cms/Leaves/Paginate.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0
    if (to.hash) {
      if (from.name === 'PublicPage') {
        if (from.hash === '#Home') {
          return { top: -50 }
        } else {
          return {
            el: to.hash,
            behavior: 'smooth'
          }
        }
      }
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }
    return goTo(scrollTo)
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (to.matched.some((record) => record.meta.logout)) {
      store.dispatch('auth/reqLogout')
    } else {
      if (store.getters['auth/user']) {
        next()
      } else {
        store.dispatch('auth/reqLogout')
      }
    }
  } else {
    if (store.getters['auth/user']) {
      store.dispatch('sidebar/setIsAactiveFalse')
      next('/home')
    } else {
      next()
    }
  }
})

export default router
